import React from 'react';
import Checkbox from 'rc-checkbox';
import TextInput from '../TextInput'
import SaveButton from '../Buttons/SaveButton'
import CancelButton from '../Buttons/CancelButton'

const UserForm = ({
    name, goBack, username, password, phone, status, onSubmit, onTextChange, onCheckChange, title, update,
    ADMIN, REPORTS, USER, SNAP_V2, CAR_FORM_V1, CAR_FORM_V2, CAR_FORM_V3
}) => {
    return (
        <div className="lg:m-4">
            <div className="lg:flex mr-4 ml-4">
                <div className="lg:w-1/3 bg-white m-2 border border-grey-100 rounded shadow">
                    <label className="flex m-3 font-semibold text-vivid-900">{title}</label>
                    <hr className="m-2"></hr>
                    <form className="w-full flex flex-col">
                        <div className="flex flex-wrap mb-6">
                            <div className="w-full px-3">
                                <label htmlFor="name" className="block uppercase tracking-wide text-grey-700 text-sm font-normal mb-2">
                                    الاســم
                                </label>
                                <TextInput value={name} required onChange={onTextChange} className="appearance-none block w-full bg-grey-100 text-grey-700 border border-grey-100 rounded py-2 px-3 leading-tight focus:outline-none focus:bg-white focus:border-grey-400" name="name" type="tel" placeholder="name" />
                            </div>
                        </div>
                        <div className="flex flex-wrap mb-6">
                            <div className="w-full px-3">
                                <label htmlFor="username" className="block uppercase tracking-wide text-grey-700 text-sm font-normal mb-2">
                                    اسم المستخدم
                                </label>
                                <TextInput value={username} onChange={onTextChange} className="appearance-none block w-full bg-grey-100 text-grey-700 border border-grey-100 rounded py-2 px-3 leading-tight focus:outline-none focus:bg-white focus:border-grey-400" name="username" type="text" />
                            </div>
                        </div>
                        <div className="flex flex-wrap mb-6">
                            <div className="w-full px-3">
                                <label htmlFor="username" className="block uppercase tracking-wide text-grey-700 text-sm font-normal mb-2">
                                    الفرع
                                </label>
                                <TextInput value={phone} onChange={onTextChange} className="appearance-none block w-full bg-grey-100 text-grey-700 border border-grey-100 rounded py-2 px-3 leading-tight focus:outline-none focus:bg-white focus:border-grey-400" name="phone" type="text" />
                            </div>
                        </div>
                        {!update && <div className="flex flex-wrap mb-6">
                            <div className="w-full px-3">
                                <label htmlFor="password" className="block uppercase tracking-wide text-grey-700 text-sm font-normal mb-2">
                                    كلمة السر
                                </label>
                                <input value={password} onChange={onTextChange} className="w-full block h-8 text-grey-700 mt-2 pr-2 bg-grey-050 rounded text-sm focus:outline-none focus:bg-white focus:border-grey-200 border border-grey-100 leading-tight" name="password" type="password" placeholder="**********"></input>
                            </div>
                        </div>}
                        <div className="flex flex-wrap mb-6">
                            <div className="w-full px-3">
                                <Checkbox
                                    id="1"
                                    size={2}
                                    borderThickness={1}
                                    checked={status}
                                    delay={0}
                                    color="#7CC4FA"
                                    onChange={onCheckChange("status")}
                                    backAnimationDuration={5}
                                    tickAnimationDuration={0}
                                />
                                <label htmlFor="status" className="text-grey-500 text-sm font-normal"> فعال ؟</label>
                            </div>
                        </div>
                        <hr className="m-2"></hr>
                    </form>
                </div>
                <div className="lg:w-2/3 bg-white m-2 border border-grey-100 rounded shadow">
                    <label className="flex m-3 font-semibold text-vivid-900">الصلاحيات الرئيسية</label>
                    <hr className="m-2"></hr>
                    <div className="flex flex-wrap mb-6">
                        <div className="w-1/6">
                            <Checkbox
                                id="1"
                                size={2}
                                borderThickness={1}
                                checked={ADMIN}
                                delay={0}
                                color="#7CC4FA"
                                onChange={onCheckChange("ADMIN")}
                                backAnimationDuration={5}
                                tickAnimationDuration={0}
                            />
                            <label className="text-vivid-700 text-sm font-normal">مدير النظام</label>
                        </div>
                        <div className="w-1/6">
                            <Checkbox
                                id="1"
                                size={2}
                                borderThickness={1}
                                checked={USER}
                                delay={0}
                                color="#7CC4FA"
                                onChange={onCheckChange("USER")}
                                backAnimationDuration={5}
                                tickAnimationDuration={0}
                            />
                            <label className="text-vivid-700 text-sm font-normal">مستخدم</label>
                        </div>
                        <div className="w-1/6">
                            <Checkbox
                                id="1"
                                size={2}
                                borderThickness={1}
                                checked={REPORTS}
                                delay={0}
                                color="#7CC4FA"
                                onChange={onCheckChange("REPORTS")}
                                backAnimationDuration={5}
                                tickAnimationDuration={0}
                            />
                            <label className="text-vivid-700 text-sm font-normal">التقارير</label>
                        </div>
                        <div className="w-1/6">
                            <Checkbox
                                id="1"
                                size={2}
                                borderThickness={1}
                                checked={SNAP_V2}
                                delay={0}
                                color="#7CC4FA"
                                onChange={onCheckChange("SNAP_V2")}
                                backAnimationDuration={5}
                                tickAnimationDuration={0}
                            />
                            <label className="text-vivid-700 text-sm font-normal">التصوير المفرغ</label>
                        </div>
                        <div className="w-1/6">
                            <Checkbox
                                id="1"
                                size={2}
                                borderThickness={1}
                                checked={CAR_FORM_V1}
                                delay={0}
                                color="#7CC4FA"
                                onChange={onCheckChange("CAR_FORM_V1")}
                                backAnimationDuration={5}
                                tickAnimationDuration={0}
                            />
                            <label className="text-vivid-700 text-sm font-normal">التقرير V1</label>
                        </div>
                        <div className="w-1/6">
                            <Checkbox
                                id="1"
                                size={2}
                                borderThickness={1}
                                checked={CAR_FORM_V2}
                                delay={0}
                                color="#7CC4FA"
                                onChange={onCheckChange("CAR_FORM_V2")}
                                backAnimationDuration={5}
                                tickAnimationDuration={0}
                            />
                            <label className="text-vivid-700 text-sm font-normal">التقرير V2</label>
                        </div>
                        <div className="w-1/6">
                            <Checkbox
                                id="1"
                                size={2}
                                borderThickness={1}
                                checked={CAR_FORM_V3}
                                delay={0}
                                color="#7CC4FA"
                                onChange={onCheckChange("CAR_FORM_V3")}
                                backAnimationDuration={5}
                                tickAnimationDuration={0}
                            />
                            <label className="text-vivid-700 text-sm font-normal">التقرير V3</label>
                        </div>
                    </div>
                </div>
            </div>
            <div className="flex flex-row-reverse ml-6">
                <CancelButton onClick={goBack} text="الغـاء" />
                <SaveButton onClick={onSubmit} text={update ? "تحديث" : "حفـظ"} />
            </div>
        </div>

    );
};

export default UserForm;